import { useEffect, useState } from "react";
import { CircularProgress } from "@firecms/ui";
import logoUrl from "../assets/logo.svg";

export function AdminBootSplash() {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setFadeIn(true), 50);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div
      className="flex min-h-screen min-w-full flex-col items-center justify-center p-4"
      style={{
        opacity: fadeIn ? 1 : 0,
        transition: "opacity 0.6s ease-in-out",
      }}
    >
      <div className="flex w-full max-w-[500px] flex-col items-center">
        <div className="m-4 h-64 w-64 p-1">
          <img
            src={logoUrl}
            alt="TeamOps"
            className="h-full w-full object-contain"
          />
        </div>
        <CircularProgress size="medium" />
      </div>
    </div>
  );
}
